import { css, cx } from '@linaria/atomic';
import { Icon } from '@frontend/icons';
import { BoolInput } from '../../atoms/bool-input.component';
import type { BoolInputProps } from '../../layouts/types';
import { SwitchStyles } from './switch.styles';

const switchCursorPointer = css`
  cursor: pointer;
`;

const switchCursorDisabled = css`
  cursor: not-allowed;
`;

export const Switch = ({ active, disabled, error, value, indeterminate, ...rest }: BoolInputProps<'switch'>) => {
  const style = SwitchStyles.switch({ disabled, active, error, value, indeterminate });
  return (
    <div className={cx(style, disabled ? switchCursorDisabled : switchCursorPointer)}>
      {indeterminate && (
        <Icon name='minus' color='primary' className='icon' onClickCapture={(e) => e.preventDefault()} />
      )}
      <BoolInput {...rest} type='checkbox' checked={value} disabled={disabled} />
    </div>
  );
};
